import React from 'react';
import classNames from 'classnames';
import { Button as LMCButton } from 'lmc-ui-library';

import { Props } from './Button.types';

const Button: React.FC<Props> = ({ children, mode = 'ghost', ...props }) => {
  return (
    <div className={classNames(mode, props.className)}>
      <LMCButton {...props} mode={mode} small borderVariant="rectangle">
        {children}
      </LMCButton>
    </div>
  );
};

export default Button;
